/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from "@ngrx/store";
import { ElectricalSettingsObjectInformation } from "../../models/electrical-settings-information";
import { ElectricalSettingsStatusResult } from "../../models/electrical-settings-return";
import { ElectricalSettingsObject } from "../../models/electrical-settings-shortcuts";
import { ApplyPreferencesSuccess, GetElectricalShortcutsModifiersInformationSuccess, GetElectricalSystemsInformationSuccess, GetInvalidShortcutsSuccess } from "./electrical-settings-actions";

export const ElectricalSettingsKey = 'ElectricalSettings';

export interface ElectricalSettingsState {
    electricalInformation?: ElectricalSettingsObjectInformation;
    shortcuts?: ElectricalSettingsObject;
    invalidShortcuts?: ElectricalSettingsStatusResult;
    applyPreferences?: boolean;
}

export const initialElectricalSettingsState: ElectricalSettingsState = {
    electricalInformation: new ElectricalSettingsObjectInformation,
    shortcuts: new ElectricalSettingsObject,
    invalidShortcuts: new ElectricalSettingsStatusResult,
    applyPreferences: false
};

export const ElectricalSettingsReducer = createReducer(
    initialElectricalSettingsState,

    on(GetElectricalSystemsInformationSuccess, (state, action) => {
        return ({
            ...state,
            electricalInformation: action.electricalInformation
        })
    }),
    on(GetElectricalShortcutsModifiersInformationSuccess, (state, action) => {
        return ({
            ...state,
            shortcuts: action.shortcuts
        })
    }),
    on(GetInvalidShortcutsSuccess, (state, action) => {
        return ({
            ...state,
            invalidShortcuts: action.invalidShortcuts
        })
    }),
    on(ApplyPreferencesSuccess, (state) => {
        return ({
            ...state
        })
    }),
);
